import { render, staticRenderFns } from "./AdministrativeStaff.vue?vue&type=template&id=34b35034&scoped=true"
import script from "./AdministrativeStaff.vue?vue&type=script&lang=js"
export * from "./AdministrativeStaff.vue?vue&type=script&lang=js"
import style0 from "./AdministrativeStaff.vue?vue&type=style&index=0&id=34b35034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b35034",
  null
  
)

export default component.exports